export const togglePlan = () => {
  const membershipPage = document.querySelector('.membership-page');
  const togglePlanBtn = document.querySelector('.membership-page__toggle-btn');

  const toggle = () => {
    membershipPage.classList.toggle('yearly');
  };

  if (togglePlanBtn && membershipPage) {
    togglePlanBtn.addEventListener('click', toggle);
  }
};
